"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScopeSelector = void 0;

var _AuthAdminSelectors = require("pricing-pages-unified-ui/selectors/AuthAdminSelectors");

var hasScopeSelector = function hasScopeSelector(state, scope) {
  var auth = (0, _AuthAdminSelectors.authSelector)(state);
  return auth && auth.user && auth.user.scopes && auth.user.scopes.indexOf(scope) > -1;
};

exports.hasScopeSelector = hasScopeSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ScopeSelectors.js
// module id = 413
// module chunks = 5 6 7